import GraphQL from './GraphQL'

class OrderClass {
    constructor() {
        this.url = '/personal/order/make/'
    }

    getData(cb, fields={
        CASH_STORE_ID : null,
        persons : {
            ID : null, 
            NAME : null,
            ACTIVE : null, 
            CODE : null, 
            SORT : null,
        },
        payments : {
            ID : null, 
            NAME : null,
            ACTIVE : null, 
            CODE : null, 
            SORT : null,
            PSA_NAME : null,
            DESCRIPTION : null,
            LOGOTIP : null,
        },
        delivery : {
            ID : null, 
            NAME : null,
            ACTIVE : null, 
            CODE : null, 
            SORT : null,
            CURRENCY : null,
            DESCRIPTION : null,
            LOGOTIP : null,
            PRICE : null,
            PERIOD_FROM : null,
            PERIOD_TO : null,
            PERIOD_TYPE : null,
            PICKUP : null,
            STORES : {
                ID : null,
                TITLE : null,
                ACTIVE : null,
                ADDRESS : null,
                DESCRIPTION : null,
                GPS_N : null,
                GPS_S : null,
                PHONE : null,
                SCHEDULE : null,
                SORT : null,
                EMAIL : null,
                ISSUING_CENTER : null,
                SHIPPING_CENTER : null,
                CODE : null,
            }
        },
        stores : {
            ID : null,
            TITLE : null,
            ACTIVE : null,
            ADDRESS : null,
            DESCRIPTION : null,
            GPS_N : null,
            GPS_S : null,
            PHONE : null,
            SCHEDULE : null,
            SORT : null,
            EMAIL : null,
            ISSUING_CENTER : null,
            SHIPPING_CENTER : null,
            CODE : null,
        },
        properties : {
            ID : null, 
            NAME : null,
            PERSON_TYPE_ID : null,
            CODE : null, 
            SORT : null,
            PROPERTIES : {
                ID : null, 
                NAME : null,
                TYPE : null,
                PROPS_GROUP_ID : null, 
                PERSON_TYPE_ID : null,
                IS_ADDRESS : null,
                IS_PHONE : null, 
                IS_ZIP : null,
                ACTIVE : null, 
                REQUIRED : null, 
                CODE : null, 
                SORT : null,
                DESCRIPTION : null,
                DEFAULT_VALUE : null,
                SETTINGS : {
                    MINLENGTH : null,
                    MAXLENGTH : null,
                    PATTERN : null,
                    MULTILINE: null,
                    SIZE : null
                }, 
                RELATIONS : {
                    PAYMENTS : null,
                    DELIVERY : null
                } 
            },
        },
        propertiesList : {
            ID : null, 
            NAME : null,
            TYPE : null,
            PROPS_GROUP_ID : null, 
            PERSON_TYPE_ID : null,
            IS_ADDRESS : null,
            IS_PHONE : null, 
            IS_ZIP : null,
            ACTIVE : null,  
            REQUIRED : null, 
            CODE : null, 
            SORT : null,
            DESCRIPTION : null,
            DEFAULT_VALUE : null, 
            SETTINGS : {
                MINLENGTH : null,
                MAXLENGTH : null,
                PATTERN : null,
                MULTILINE: null,
                SIZE : null
            }, 
            RELATIONS : {
                PAYMENTS : null,
                DELIVERY : null
            }
        },
        restrictions : {
            DELIVERY : {
                ID : null,
                LOCATIONS : null,
                EXCLUDE_LOCATIONS : null, 
                PAYMENTS : null,
                PERSONS : null,
            },
            PAYMENTS : {
                ID : null,
                DELIVERY : null,
                PERSONS : null,
            }
        },
        current_location : {
            ID : null, 
            COUNTRY : null, 
            COUNTRY_CODE : null, 
            REGION : null, 
            CITY : null, 
            ZIP : null, 
            LATITUDE : null, 
            LONGITUDE : null, 
            TIMEZONE : null, 
            LANG : null
        },
        delivery_pick_points : null,
        cart_info : {
            count : null, 
            count_format : null, 
            summary : null, 
            summary_format : null, 
            discount_summary : null, 
            discount_summary_format : null
        }
    }) {
        GraphQL.query('order_get_data', {
            
        }, fields, cb)
    }

    getDeliveryCalculate(cb, params={
        DELIVERY_ID : null, 
        PAYMENT_ID : null, 
        LOCATION_ID : null, 
        ZIP : null,
        PERSON_TYPE_ID : null
    }, fields={ PRICE : null, PERIOD : null }) {
        GraphQL.query('order_delivery_calculate', {
            'DELIVERY_ID : Int!' : params.DELIVERY_ID,
            'LOCATION_ID : Int!' : params.LOCATION_ID,
            'ZIP : String!' : params.ZIP,
            'PAYMENT_ID : Int!' : params.PAYMENT_ID,
            'PERSON_TYPE_ID : Int!' : params.PERSON_TYPE_ID,
        }, fields, cb)
    }

    send(cb, DATA) {
        GraphQL.query('order_create', {
            'DATA : String!' : DATA,
        }, {}, cb)
    }

    check(cb, DATA) {
        GraphQL.query('order_check', {
            'DATA : String!' : DATA,
        }, {}, cb)
    }

    getPaymentLink(cb, params={ ORDER_ID : null, ACCOUNT_NUMBER : null }) {
        GraphQL.query('order_get_payment_link', {
            'ORDER_ID : Int' : params.ORDER_ID,
            'ACCOUNT_NUMBER : String' : params.ACCOUNT_NUMBER,
        }, {}, cb)
    }

    sendOneClick(cb, params={
        FULL_NAME : null,
        PHONE : null,
        EMAIL : null,
        ADDRESS : null,
        LINK : null
    }) {
        GraphQL.query('send_order_one_click', {
            'FULL_NAME : String!' : params.FULL_NAME,
            'PHONE : String!' : params.PHONE,
            'EMAIL : String!' : params.EMAIL,
            'ADDRESS : String!' : params.ADDRESS,
            'LINK : String' : params.LINK,
        }, {}, cb)
    }

    sendOrderCall(cb, params={
        FULL_NAME : null,
        PHONE : null,
        EMAIL : null,
        LINK : null
    }) {
        GraphQL.query('send_order_call', {
            'FULL_NAME : String!' : params.FULL_NAME,
            'PHONE : String!' : params.PHONE,
            'EMAIL : String!' : params.EMAIL,
            'LINK : String' : params.LINK,
        }, {}, cb)
    }
}

const Order = new OrderClass()

export default Order